import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { isPlatformBrowser, ViewportScroller } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { Categorias } from 'src/app/interfaces/categorias';
import { Empresas } from 'src/app/interfaces/empresas';
import { Estadisticas } from 'src/app/interfaces/inicio';
import { InicioService } from 'src/app/services/inicio/inicio.service';
import { Router } from '@angular/router';
import { VacantesService } from 'src/app/services/vacante/vacantes.service';
import { Vacante, VacanteDTO} from 'src/app/interfaces/vacantes';
import { environment } from 'src/environments/environment';
import { JwtResponse } from 'src/app/interfaces/jwt';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { AlertService } from 'src/app/services/alert/alert.service';
import { construirUrlArchivo } from 'src/app/utils/imagen-url.util';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  usuario: JwtResponse;
  usuarioRol: string;
  verArchivos: string;
  categoriasEmpleos: Categorias[];
  estadisticas: Estadisticas = {} as Estadisticas;
  empresas: Empresas[];
  vacantes: Vacante[];
  cantidadVacantes: number;
  noPagina: number;
  idCategoria: number;
  mensajeError: string;
  vacantesDto: VacanteDTO[];
  defaultLogo: string = 'assets/img/user/empresa-default.png';

  busquedaTitulo = '';
  paisBusqueda = '';
  categoriaBusqueda = 0;
  paises: string[] = [];

  showFreeBanner = true;



  constructor(private title: Title, private meta: Meta, private router: Router, private inicioService: InicioService,
    private vacantesService: VacantesService, @Inject(PLATFORM_ID) private platformId: object,
    private scroller: ViewportScroller, private http: HttpClient, private alertService: AlertService) {
      this.usuario = JSON.parse(localStorage.getItem('currentUser'));
      this.usuarioRol = '';
      this.agregarMetaData();
      this.cantidadVacantes = 6;
      this.idCategoria = 0;
      this.verArchivos = environment.baseArchivos;
    }


  ngOnInit(): void {
    if(this.usuario){
      this.usuarioRol = this.usuario.role;
      // Verificar si ya usó el freebie
      const candidatoId = this.usuario.user?.idUsuario;
      if (candidatoId) {
        this.alertService.getEstado(candidatoId).subscribe({
          next: (res: any) => {
            const data = res?.data || res;
            if (data?.isPremium || data?.freebieUsado || data?.freebiePromptDismissed) {
              this.showFreeBanner = false;
            }
          }
        });
      }
    }

    this.obtenerVacantesFiltro(1,0);
    this.obtenerCategoriaEmpresasInicio();
    this.obtenerEstadisticasInicio();
    this.obtenerEmpresasInicio();
    this.obtenerPaisesInicio();
  }
  private agregarMetaData(): void {
    this.title.setTitle('Tec Gurus - Empleos');
    this.meta.updateTag({name: "description", content: "Tec Gurus empresa establecida durante más de 10 años, ofrece servicios de capacitación, busqueda de talento y consultoría en desarrollo de software."});//falta descripcion e imagen para mostrar en open graph
    this.meta.updateTag({name: "keywords", content: "registro, empresas, postulaciones, vacantes, salario, programador, buscar empleo, empleos"});
    this.meta.updateTag({name: "robots", content: "noodp"});
    this.meta.updateTag({property: "og:title", content: "Tec Gurus - Empleos"});
    this.meta.updateTag({property: "og:description", content: "Tec Gurus empresa establecida durante más de 10 años, ofrece servicios de capacitación, busqueda de talento y consultoría en desarrollo de software."});
    this.meta.updateTag({property: "og:url", content: environment.baseTG});
    this.meta.updateTag({property: "og:site_name", content: "TG Empleos"});
    this.meta.updateTag({property: "og:locale", content: "es_ES"});
    this.meta.updateTag({property: "og:type", content: "website"});
    this.meta.updateTag({property: "og:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:title", content: "Tec Gurus - Empleos"});
    this.meta.updateTag({name: "twitter:description", content:"Tec Gurus empresa establecida durante más de 10 años, ofrece servicios de capacitación, busqueda de talento y consultoría en desarrollo de software."});
    this.meta.updateTag({name: "twitter:site", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:creator", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:card", content: "summary"});
  }

  async obtenerVacantesFiltro(tiempo: number, idModalidadEmpleo: number) {
    try {
      // Antes llamaba a /publico/vacantes/todas sin filtros reales (tiempo/modalidad no los
      // procesa ese endpoint) — traía TODO el listado completo solo para mostrar 6. Se usa el
      // endpoint paginado pidiendo directamente solo 6, mucho más rápido con muchas vacantes.
      const response: any = await this.vacantesService.obtenerVacantesPaginadas({}, 0, 6);
      this.vacantes = response.data?.content ?? [];

      if (this.vacantes.length === 0) {
        this.mensajeError = "Lo sentimos, no hay vacantes disponibles.";
        setTimeout(() => this.mensajeError = "", 3000);
        return;
      }

      this.noPagina = 1;
      this.vacantes.forEach(vacante => {
        vacante.logo = construirUrlArchivo(vacante.logo, environment.empresaDefault);
      });
      this.vacantes = this.mezclarVacantes(this.vacantes);
    } catch (error) {
      console.error("Error al obtener las vacantes por filtro", error);
    }
  }



  async obtenerCategoriaEmpresasInicio(){
    try {
      const response = await this.inicioService.obtenerCategoriasEmpresas();
      this.categoriasEmpleos = response.data;
    } catch (error) {
      console.error("Error al obtener las categorías", error);
    }
  }

  async obtenerPaisesInicio(){
    try {
      this.paises = await this.vacantesService.getPaises();
    } catch (error) {
      console.error("Error al obtener países", error);
    }
  }

  async obtenerEstadisticasInicio(){
    try {
      const response = await this.inicioService.obtenerEstadisticas();
      this.estadisticas = response.data;
    } catch (error) {
      console.error("error al obtener las estadisticas", error);
    }
  }

  async obtenerEmpresasInicio(){
    try {
        const response = await this.inicioService.obtenerEmpresasPopulares();
        this.empresas = response.data;
        if(this.empresas){
          this.empresas.forEach(empresa => {
            empresa.logo = construirUrlArchivo(empresa.logo, environment.empresaDefault);
          });
        }
    } catch (error) {
        console.error("Error al traer empresas populares", error);
    }
  }

  redirigirUrl(url: string): void{
    const isUrl = /^http[s]?/;
    if(!isUrl.test(url)){
      url = 'https://' + url;
    }

    if (isPlatformBrowser(this.platformId)) {
      window.open(url, '_blank');
    }
  }

  scrollToElement($element): void {
    $element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }

  seleccionarIdEmpresa(idEmpresa: number){
    if(this.usuarioRol){
      this.router.navigate(['empresas/detalles/'+idEmpresa]);
    }
  }

  onSelect(id: number){
     this.idCategoria = id;
  }

  buscarVacante(): void {
    const queryParams: any = {};
    if (this.busquedaTitulo.trim()) queryParams.titulo = this.busquedaTitulo.trim();
    if (this.paisBusqueda) queryParams.pais = this.paisBusqueda;
    if (this.categoriaBusqueda && this.categoriaBusqueda != 0) queryParams.catId = this.categoriaBusqueda;
    this.router.navigate(['/vacantes'], { queryParams });
  }

  filtroPorCategoria(catId: number, nombreCategoria: string){
    if(catId){
      this.router.navigate(['/vacantes'], { queryParams: { catId: catId, q: nombreCategoria } });
    }
  }

  verDetalles(vacante: Vacante){
    localStorage.setItem('idVacante', vacante.idVacante.toString());
    if(localStorage.getItem('idVacante')){
        this.router.navigate(['/vacantes/detalles/'+vacante.urlVacante]);
    }
  }

  scrollVacantes(){
    this.scroller.scrollToAnchor("containerVacantes");
  }

  optionsSlides: OwlOptions = {
		loop: true,
		nav: true,
		dots: false,
		autoplayHoverPause: true,
		autoplay: true,
		margin: 30,
		navText: [
			"<i class='icofont-arrow-left'></i>",
			"<i class='icofont-arrow-right'></i>"
		],
		responsive: {
			0: {
				items: 1
			},
			576: {
				items: 2
			},
			768: {
				items: 3
			},
			1200: {
				items: 4
			}
		}
  }
  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = this.defaultLogo;
  }

formatSalario(salario: string): string {
         if (salario && salario.trim() !== '' && /^\d/.test
     (salario.trim())) {
          return '$' + salario;
         }
         return salario;
       }



 private mezclarVacantes(vacantes: Vacante[]): Vacante[] {
  const cantidadMezclar = 12;

  if (vacantes.length < 2) {
    return vacantes;
  }

  const primeras = vacantes.slice(0, cantidadMezclar);
  const restantes = vacantes.slice(cantidadMezclar);

  for (let i = primeras.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [primeras[i], primeras[j]] = [primeras[j], primeras[i]];
  }
  return [...primeras, ...restantes];
}

private getFechaVacante(v: any): Date | null {
  const raw = v.createdAt || v.fechaCreado || v.updatedAt || v.fechaActualizacion;
  if (!raw) { return null; }
  const d = new Date(raw);
  return isNaN(d.getTime()) ? null : d;
}

private filterByLastMonths(vacantes: any[], months = 6): any[] {
  if (!Array.isArray(vacantes) || !vacantes.length) return [];
  const now = new Date();
  const cutoff = new Date(now);
  cutoff.setMonth(now.getMonth() - months);

  return vacantes.filter(v => {
    const d = this.getFechaVacante(v);
    return d ? d >= cutoff && d <= now : false;
  });
}


}
